import Slideout from "slideout";

const slideoutMenuElem = document.getElementById("menu");
if (slideoutMenuElem) {
    const slideout = new Slideout({
        panel: document.getElementById("clarius-panel"),
        menu: slideoutMenuElem,
        padding: 256,
        tolerance: 70,
        grabWidth: 40,
    });

    // Slideout 1.x registers its document-level touchmove without {passive: false}.
    // Chrome forces document-level touch listeners passive, so the library's
    // preventDefault() is ignored and trips a ReportingObserver intervention.
    document.removeEventListener("touchmove", slideout._preventMove);
    document.addEventListener("touchmove", slideout._preventMove, { passive: false });

    // Toggle button
    globalThis.toggleSidebar = function () {
        slideout.toggle();
    };
}

export const inst_id = JSON.parse(document.getElementById("inst-id").textContent);
